var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadar = function SvgRadar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "radar_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#radar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.493 20.292a9.1 9.1 0 0 1-2.859-1.924 9.1 9.1 0 0 1-1.925-2.856A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.923-2.859 9.1 9.1 0 0 1 2.857-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.923 9.1 9.1 0 0 1 1.925 2.857A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709 8.8 8.8 0 0 1-3.51-.709M12 20a7.7 7.7 0 0 0 2.873-.534 8.2 8.2 0 0 0 2.412-1.468l-2.118-2.117q-.648.525-1.46.822A4.9 4.9 0 0 1 12 17q-2.084 0-3.542-1.457Q7 14.087 7 12.005T8.457 8.46Q9.913 7 11.995 7t3.544 1.458T17 12q0 .898-.3 1.709a5.2 5.2 0 0 1-.825 1.464l2.117 2.118a8.2 8.2 0 0 0 1.471-2.41A7.7 7.7 0 0 0 20 12q0-3.35-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20m0-4q.678 0 1.309-.224t1.139-.614l-2.198-2.199a.5.5 0 0 1-.123.031 1 1 0 0 1-.123.006q-.406 0-.705-.299A.96.96 0 0 1 11 12q0-.402.299-.701A.96.96 0 0 1 12 11q.402 0 .701.299.3.3.299.697 0 .072-.006.139a.5.5 0 0 1-.03.127l2.192 2.192q.39-.508.617-1.131Q16 12.699 16 12q0-1.65-1.175-2.825T12 8 9.175 9.175 8 12t1.175 2.825T12 16"
  }))));
};
export default SvgRadar;